import React, { useState } from 'react';
import Modal from './Modal';
import './PublicarManualModal.css';

const PublicarManualModal = ({ isOpen, onClose, post, onPublish }) => {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validación básica
    if (!url.trim()) {
      setError('La URL de publicación es requerida');
      return;
    }

    // Validación de URL
    try {
      new URL(url);
    } catch (err) {
      setError('Por favor ingresa una URL válida (ejemplo: https://instagram.com/p/...)');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await onPublish(post.id, url);
      // Limpiar y cerrar
      setUrl('');
      onClose();
    } catch (error) {
      console.error('Error al publicar manualmente:', error);
      setError(error.response?.data?.error || 'Error al guardar la publicación');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setUrl('');
      setError('');
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Publicar Manual"
      subtitle={post?.title}
      icon="📝"
      size="m"
      closeOnOverlayClick={!loading}
      footer={
        <>
          <button
            type="button"
            onClick={handleClose}
            className="btn-cancel"
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="submit"
            onClick={handleSubmit}
            className="btn-submit"
            disabled={loading}
          >
            {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="publicar-manual-form">
        <div className="form-group">
          <label htmlFor="url_publicacion" className="form-label">
            URL de Publicación <span className="required">*</span>
          </label>
          <input
            type="url"
            id="url_publicacion"
            className="form-input"
            placeholder="https://instagram.com/p/..."
            value={url}
            onChange={(e) => {
              setUrl(e.target.value);
              setError('');
            }}
            disabled={loading}
            required
          />
          <p className="form-help">
            Ingresa la URL donde se publicó manualmente el contenido
          </p>
          {error && <p className="form-error">{error}</p>}
        </div>

        <div className="info-box">
          <div className="info-box-header">
            <span className="info-icon">ℹ️</span>
            <strong>Información</strong>
          </div>
          <p className="info-box-text">
            Al guardar, el estado del post cambiará a <strong>"Publicado"</strong> y
            se guardará la URL para futuro seguimiento.
          </p>
        </div>
      </form>
    </Modal>
  );
};

export default PublicarManualModal;
